import React, { useEffect, useRef } from "react"

import { connect } from "react-redux"

import { withTranslation, useTranslation } from "react-i18next"

import ShopItemComponent from "./ShopItemComponent"
import { getActiveVehicle } from "../../../../helpers/vehicleHelpers"
import { MD_HD_VEHICLE_TYPE_ID } from "../../../../constants/application"
import FeaturedLabel from "./FeaturedLabel"
import ModalDialog from "../../../../components/ModalDialog"
import { filteredShops } from "../../../../helpers/shopHelpers"
import ReactSVG from "react-svg"
import ToolTipIcon from "../../../../../images/info_icon_vector.svg"
import CALogo from "../../../../../images/CA_CheckIcon.svg"

const ShopListViewItemComponent = (props) => {
  const { t } = useTranslation("dashboardMapComponent")

  let vehicleTypeId
  if (props.user) {
    const activeVehicle = getActiveVehicle()
    vehicleTypeId = (activeVehicle && activeVehicle.vehicle_type_id) || null
  }

  const shopList = filteredShops(props.shops)
  const isMDHDVehicle = vehicleTypeId === MD_HD_VEHICLE_TYPE_ID
  const ref = useRef(null)

  useEffect(() => {
    const setHeight = () => {
      const sectionA = document.querySelector(".dashboard-just-for-you-container")
      if (sectionA && ref.current) {
        ref.current.style.height =
          sectionA.offsetHeight < 500 ? "500px" : `${sectionA.offsetHeight - 125}px`
      } else {
        if (ref?.current?.style) {
          ref.current.style.height = "500px"
        }
      }
    }

    setHeight()
    window.addEventListener("sectionAHeightChanged", setHeight)
    window.addEventListener("resize", setHeight)

    return () => window.removeEventListener("resize", setHeight)
  }, [])
  return (
    <div
      className={`shopListView ${isMDHDVehicle ? "shopListView-with-md-hd" : ""}`}
      id="shopListViewMap"
      ref={ref}
    >
      {props.shops && props.shops.length > 0 ? (
        shopList?.allShops?.map((shop, index) => (
          <>
            {shopList.sponsoredShops && shopList.sponsoredShops.length > 0 && index == 0 && (
              <div className="sponsored-shop-label">
                <span>
                  {t("sponsoredShopLabel")}
                  <ModalDialog
                    linkText={<ReactSVG src={ToolTipIcon} />}
                    className="primary-button-color"
                  >
                    {t("sponsoredShopInfo")}
                  </ModalDialog>
                </span>
              </div>
            )}
            {index == shopList.sponsoredShops.length && (
              <div className="sponsored-shop-label">{t("closestToYouLabel")}</div>
            )}
            <FeaturedLabel shop={shop} listView={true} />
            <ShopItemComponent
              showMapExpanded={true}
              key={index}
              onClose={props.onClose}
              shop={shop}
              onSelectShopClick={props.onSelectShopClick}
              setShopSelectedOnMap={props?.setShopSelectedOnMap}
              informationOnly={props?.informationOnly}
            />
          </>
        ))
      ) : (
        <div className={props.showMapExpanded ? "noShopFoundExpanded" : "noShopFound"}>
          <div className="shop-selection-placeholder">
            <ReactSVG className={"ca-logo"} src={CALogo} />
            <p className="placeholder-text">
              {t("searchShops", {
                SHOPS: "32,000"
              })}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  let user = state.user
  return { user: user }
}

export default connect(mapStateToProps)(
  withTranslation("dashboardMapComponent")(ShopListViewItemComponent)
)
